/* global $ */

const $popover = $('.js-popover');

const popover = {
  initialize() {
    if ($popover.length) {
      this.createListeners();
    }
  },

  createListeners() {
    $('[data-toggle="popover"]').popover({
      trigger: 'focus',
    });
  },
};

export default popover;
